import { Link, NavLink, Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import PrismWordmark from "./ui/PrismWordmark";
import { LoginPage } from "./pages/LoginPage";
import { StatsPage } from "./pages/StatsPage";
import { AccountsPage } from "./pages/AccountsPage";
import { AccountDetailPage } from "./pages/AccountDetailPage";
import { EventsPage } from "./pages/EventsPage";

function Header() {
  const { state, clearSession } = useAuth();
  return (
    <div className="header">
      <Link to="/" aria-label="Prism — admin" style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>
        <PrismWordmark height={28} />
        <span style={{ fontFamily: "var(--font-mono)", fontSize: 11, letterSpacing: "0.4em", color: "var(--text-muted)", textTransform: "uppercase" }}>
          admin
        </span>
      </Link>
      {state.status === "authenticated" && (
        <nav className="nav">
          <NavLink to="/" end>Stats</NavLink>
          <NavLink to="/accounts">Accounts</NavLink>
          <NavLink to="/events">Events</NavLink>
          <button className="btn" onClick={clearSession}>Sign out</button>
        </nav>
      )}
    </div>
  );
}

function RequireAuth({ children }: { children: JSX.Element }) {
  const { state } = useAuth();
  if (state.status !== "authenticated") return <Navigate to="/login" replace />;
  return children;
}

export function App() {
  return (
    <div className="layout">
      <Header />
      <main className="main">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<RequireAuth><StatsPage /></RequireAuth>} />
          <Route path="/accounts" element={<RequireAuth><AccountsPage /></RequireAuth>} />
          <Route path="/accounts/:id" element={<RequireAuth><AccountDetailPage /></RequireAuth>} />
          <Route path="/events" element={<RequireAuth><EventsPage /></RequireAuth>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}
